var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.86 7.925 3.3 9.875a1 1 0 0 0 .78 1.625h7.84a1 1 0 0 0 .78-1.625l-1.56-1.95a3 3 0 0 1-.399-3.093l.634-1.426A1 1 0 0 0 10.461 2H5.54a1 1 0 0 0-.914 1.406l.634 1.426a3 3 0 0 1-.399 3.093Z",
    opacity: 0.12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.539 2.625a.375.375 0 0 0-.343.527L5.83 4.58a3.625 3.625 0 0 1-.482 3.736l-1.56 1.95a.375.375 0 0 0 .293.61h7.838c.315 0 .49-.364.293-.61l-1.56-1.95a3.625 3.625 0 0 1-.482-3.736l.634-1.427a.375.375 0 0 0-.343-.527H5.54ZM4.054 3.66a1.625 1.625 0 0 1 1.485-2.285h4.922a1.625 1.625 0 0 1 1.485 2.285l-.634 1.426a2.375 2.375 0 0 0 .316 2.449l1.56 1.95c.851 1.064.094 2.64-1.269 2.64H8.625V15a.625.625 0 1 1-1.25 0v-2.875H4.081c-1.363 0-2.12-1.576-1.27-2.64l1.561-1.95a2.375 2.375 0 0 0 .316-2.449L4.054 3.66Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.0ac6c8373ad11a990c1ce60fa9ea879a.svg";
export { ForwardRef as ReactComponent };